/* global axios */
import ApiClient from '../ApiClient';

class ElectoralCampaignMapAPI extends ApiClient {
  constructor() {
    super('electoral_campaign/map', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  get() {
    return axios.get(this.url);
  }

  generate({ city, state }) {
    return axios.post(`${this.url}/generate`, { city, state });
  }

  searchCity({ q, state }) {
    const params = { q };
    if (state) params.state = state;
    return axios.get(`${this.url}/search_city`, { params });
  }

  reset() {
    return axios.delete(this.url);
  }
}

export default new ElectoralCampaignMapAPI();
